module.exports = __webpack_public_path__ + "img/grade.64e386eb.png";